module.exports = __webpack_public_path__ + "Poppins-Bold.2f55e0d4b3f9eb3ffaef.ttf";


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/assets/fonts/Poppins-Bold.ttf
// module id = ../../../../../src/assets/fonts/Poppins-Bold.ttf
// module chunks = styles